import angular from 'angular';

module.exports = angular.module('common.filters.bytes', [])
.filter('bytes', function() {
  return function(bytes, precision) {
    if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
    if (typeof precision === 'undefined') precision = 1;
    let units = ['bytes', 'kb', 'mb', 'gb', 'tb', 'pb'],
	number = Math.floor(Math.log(bytes) / Math.log(1024));
    return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) +  ' ' + units[number];
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/bytes.js
 **/